import { useState } from "react";
import { useApp } from "../../../hooks/useApp"
import { getTotalPrice, getMainProductVariantById } from "../../../utils"
import { formatCentsToDollars } from "../../../utils/formatCentsToDollars"
import { Button } from "../../ui/Button/Button"
import { Text } from "../../ui/Text/Text"
import { isPos } from "../../../utils"

export const Header = () => {
  const { 
    mainProduct, 
    activeScreen, 
    setActiveScreen, 
    setActive, 
    activeMainProductVariantId, 
    activePendantProductVaraintIds, 
    reset
  } = useApp()
  const  { title, metafields: { pdpBiLine } } = mainProduct
  const activeProductVariant = getMainProductVariantById(mainProduct, activeMainProductVariantId)
  const pdpVariantBiLine = activeProductVariant.metafields.pdpBiLine
  const totalPrice = getTotalPrice(mainProduct, activeMainProductVariantId, activePendantProductVaraintIds)

  const [showResetModal, setShowResetModal] = useState(false)

  const handleReset = () => {
    setActive(1)
    setShowResetModal(false)
    reset()
  }

  return (
    <>
      <header className="absolute left-0 right-0 top-0 flex flex-col gap-1 items-center p-4 xl:hidden">
        <h1 className="text-center">
          <Text className="uppercase" style="h6">{title}</Text>
        </h1>

        <p className="block mt-[2px] text-subdued text-[12px]">
          {pdpVariantBiLine ? pdpVariantBiLine : pdpBiLine}
        </p>

        {activeScreen === "CHAIN" && (
          <Button className="text-center" onClick={() => setActiveScreen("PENDANTS")}>
            <Text style="button-quaternary-dark">Edit Charms</Text>
          </Button>
        )}

        {activeScreen === "PENDANTS" && (
          <Button className="text-center" onClick={() => setActiveScreen("CHAIN")}>
            <Text style="button-quaternary-dark">Edit Chain</Text>
          </Button>
        )}

        {isPos() && <button className="mt-4 Button Button--quaternary-dark" onClick={() => setShowResetModal(true)}>Reset</button>}
      </header>

      <header className="flex flex-col items-start xl-max:hidden">
        <h1><Text className="text-[18px] uppercase" style="h4">{title}</Text></h1>

        <div className="flex flex-col justify-between gap-2">
          <p className="block mt-XS text-subdued">
            {pdpVariantBiLine ? pdpVariantBiLine : pdpBiLine}
          </p>
          <Text style="heading">{formatCentsToDollars(totalPrice)}</Text>
        </div>

        {activeScreen === "CHAIN" && (
          <Button className="mt-5" onClick={() => setActiveScreen("PENDANTS")}>
            <Text style="button-quaternary-dark">Edit Charms</Text>
          </Button> 
        )}

        {activeScreen === "PENDANTS" && (
          <Button className="mt-5" onClick={() => setActiveScreen("CHAIN")}>
            <Text style="button-quaternary-dark">Edit Chain</Text>
          </Button>
        )}
      </header>

      {showResetModal && (<>
        <div
          className="fixed z-50 left-0 top-0 right-0 bottom-0 bg-[#343434] opacity-50"
          onClick={() => setShowResetModal(false)}
        />
        <div className="fixed left-[50%] top-1/2 z-50 opacity-100 w-[calc(100vw-2.5rem)] max-w-[360px] rounded-sm -translate-x-1/2 bg-[#FAFAF9] -translate-y-1/2">
          <div className="p-4">
            <Text className="mb-12 block text-center" style="h4">
              Are you sure you want to reset? This action cannot be undone.
            </Text>
            <div className="flex gap-3 justify-between">
              <Button
                size="md"
                onClick={() => setShowResetModal(false)}
                color="gray"
              >
                <Text style="label">Cancel</Text>
              </Button>
              <Button
                size="md"
                onClick={handleReset}
                color="black"
              >
                <Text style="label">Reset</Text>
              </Button>
            </div>
          </div>
        </div>
      </>)}
    </>
  )
}